import "./formContainer.scss";

export default function FormContainer(props: {
  hasFadeInAnimation?: boolean;
  label: string;
  isRequired: boolean;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={`
        treatz-spa-form-container
        ${props.hasFadeInAnimation === true ? "fade-in" : ""}
      `}
    >
      <div className="form-header">
        <p className="label">{props.label}</p>

        {props.isRequired === true && (
          <p className="required-text">
            <span>*</span>
            필수 선택
          </p>
        )}
      </div>

      {props.children}
    </div>
  );
}
